import {create} from 'zustand';

export type DashboardStore = {
  customerHolding: any;
  accountsHolding: any;
  wallet: any;
  summary: any;
  metals: any;
};

export const dashboardStore = create<DashboardStore>((set) => ({
  customerHolding: [],
  accountsHolding: [],
  wallet: {},
  summary: {},
  metals: [],
  metalOrder: [
    {
      id: 1,
      metalCode: 'Ag',
    },
    {
      id: 2,
      metalCode: 'Pt',
    },
    {
      id: 3,
      metalCode: 'Pd',
    },
    {
      id: 4,
      metalCode: 'Au',
    },
  ],
  setCustomerHolding: (customerHolding: any) => set({ customerHolding }),
  setAccountHolding: (accountsHolding: any) => set({ accountsHolding }),
  setWallet: (wallet: any) => set({ wallet }),
  setSummary: (summary: any) => set({ summary }),
  setMetals: (metals: any) => set({ metals }),
  clearDashboard: () =>
    set({
      customerHolding: [],
      accountsHolding: [],
      wallet: {},
      summary: {},
      metals: [],
    }),
}));
